<breadcrumb-layout *ngIf="breadcrumbStateService.navState$ | async as navState" [showMobileBackButton]="breadcrumbStateService.showMobileBackButton$ | async">
	<breadcrumb-item-view
		[tooltip]="selectedService.getOrg()?.name"
		[showBreadCrumbButton]="!isLti"
		(action)="navigateToFoldersView()"
		(contextmenu)="canOpenOrgMenu(navState, true) ? openMenu($event, orgMenu) : null">
		<span class="org">{{selectedService.getOrg()?.name}}</span>

		<button suffix *ngIf="canOpenOrgMenu(navState)"
			(click)="openMenu($event, orgMenu)"
			[attr.aria-label]="'menu-button_org' | translate"
			class="btn-none menu-trigger-btn org-menu"
			>
			<i class="ficon-app-dots-vertical"></i>
		</button>

		<menu #orgMenu>
			<org-menu [org]="selectedService.getOrg()"></org-menu>
		</menu>
	</breadcrumb-item-view>
	<breadcrumb-item-view *ngIf="orderedStates.indexOf(navState) >= 1"
	    [tooltip]="selectedService.getGroup()?.name"
		[showBreadCrumbButton]="!isLti || (isLti && isCourseLevelLti)"
		(action)="navigateToFolderView()"
		(contextmenu)="canOpenFolderMenu(navState, true) ? openMenu($event, folderMenu) : null">
		<span class="group">{{selectedService.getGroup()?.name}}</span>

		<button suffix *ngIf="canOpenFolderMenu(navState)"
			data-cy="course-menu"
			(click)="openMenu($event, folderMenu)"
			[attr.aria-label]="'menu-button_folder' | translate"
			class="btn-none menu-trigger-btn folder-menu">
			<i class="ficon-app-dots-vertical"></i>
		</button>

		<menu #folderMenu>
			<folder-menu [folder]="selectedService.getGroup()" (onArchived)="navigateToFoldersView()"></folder-menu>
		</menu>
	</breadcrumb-item-view>
	<breadcrumb-item-view *ngIf="orderedStates.indexOf(navState) >= 2"
	    [tooltip]="selectedService.getActivity()?.name"
		[showBreadCrumbButton]="true"
		(action)="navigateToActivityView()"
		(contextmenu)="canOpenActivityMenu(navState, true) ? openMenu($event, activityMenu) : null">
		<span class="activity">{{selectedService.getActivity()?.name}}</span>

		<button suffix *ngIf="canOpenActivityMenu(navState)"
			(click)="openMenu($event, activityMenu)"
			[attr.aria-label]="'menu-button_activity' | translate"
			class="btn-none menu-trigger-btn activity-menu">
			<i class="ficon-app-dots-vertical"></i>
		</button>

		<menu #activityMenu>
			<activity-menu [activity]="selectedService.getActivity()" (onArchived)="navigateToFolderView()"></activity-menu>
		</menu>
	</breadcrumb-item-view>

	<breadcrumb-item-view *ngIf="orderedStates.indexOf(navState) === 3"
	  	[tooltip]="(selectedService.selectedSubject | async)?.session?.description"
		[showBreadCrumbButton]="true">
		<div class="session-info-wrapper">
			<span class="session" *ngIf="(selectedService.selectedSubject | async)?.session?.description else untitled">
				{{(selectedService.selectedSubject | async)?.session?.description}}
			</span>
			<ng-template #untitled>
				<span class="session" translate="breadcrumbs-untitled-session"></span>
			</ng-template>
			<span *ngIf="shouldShowDraftBadge()" class="draft-badge" translate="common_draft"></span>
		</div>
	</breadcrumb-item-view>

	<ngx-expiring-license *ngIf="orderedStates.indexOf(navState) >= 1 && !shouldShowDraftBadge()"></ngx-expiring-license>
	<license-plan-breadcrumb *ngIf="orderedStates.indexOf(navState) >= 1 && !shouldShowDraftBadge()"></license-plan-breadcrumb>
	<ai-trial-badge *ngIf="orderedStates.indexOf(navState) >= 1 && !shouldShowDraftBadge()"></ai-trial-badge>
</breadcrumb-layout>
